// CalendarIcon.jsx — ISP-9999 (gordon-0915-form-block-ten-fixes, item 5).
//
// GORDON 2026-09-15 02:30 PT: "make the calendar ICON identical in Edit Wheel
// and View Wheel (View Wheel's icon is the correct one — copy it to the
// builder preview)." Before this fix, View Wheel's Date field rendered a
// native `<input type="date">` (browser-chrome calendar affordance, varies by
// engine) while the builder's static preview (FormBlock.jsx FieldPreview)
// rendered a hardcoded "📅" emoji glyph — two different, inconsistent icons.
// This ONE svg is now used by both surfaces (FormBlock.jsx's static preview
// AND FormLiveView.jsx's date-field adornment), so they can never drift again.
import React from "react";

const CalendarIcon = ({ size = 16, color = "currentColor", ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    {...rest}
  >
    <rect x="3.5" y="5" width="17" height="16" rx="2.5" stroke={color} strokeWidth="1.6" />
    <path d="M3.5 9.5h17" stroke={color} strokeWidth="1.6" />
    <path d="M8 3v3.6M16 3v3.6" stroke={color} strokeWidth="1.6" strokeLinecap="round" />
    <circle cx="8" cy="13.5" r="1.1" fill={color} />
    <circle cx="12" cy="13.5" r="1.1" fill={color} />
    <circle cx="16" cy="13.5" r="1.1" fill={color} />
  </svg>
);

export default CalendarIcon;
